import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-the-app',
  templateUrl: './the-app.component.html',
  styleUrls: ['./the-app.component.scss']
})
export class TheAppComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
